import { formatInTimeZone, fromZonedTime } from "date-fns-tz";
import { enGB } from "date-fns/locale/en-GB";

export function formatDate(dateString: string, pattern: string = "d MMMM yyyy") {
  
  const dateTime = new Date(dateString);

  if (dateTime.toString() === "Invalid Date") return dateString;

  return formatInTimeZone(fromZonedTime(dateTime, "UTC"), "Australia/Sydney", pattern, { timeZone: "Australia/Sydney", locale: enGB });
}
